var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 23.75H8.03125L20.25 11.5312L18.4688 9.75L6.25 21.9688V23.75ZM3.75 26.25V20.9375L20.25 4.46875C20.5 4.23958 20.776 4.0625 21.0781 3.9375C21.3802 3.8125 21.6979 3.75 22.0312 3.75C22.3646 3.75 22.6875 3.8125 23 3.9375C23.3125 4.0625 23.5833 4.25 23.8125 4.5L25.5312 6.25C25.7812 6.47917 25.9635 6.75 26.0781 7.0625C26.1927 7.375 26.25 7.6875 26.25 8C26.25 8.33333 26.1927 8.65104 26.0781 8.95312C25.9635 9.25521 25.7812 9.53125 25.5312 9.78125L9.0625 26.25H3.75ZM19.3438 10.6562L18.4688 9.75L20.25 11.5312L19.3438 10.6562Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1de33562a981dd3f2261707fdbc1bc10.svg";
export { ForwardRef as ReactComponent };